import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminLogin.scss';

export default function AdminLogin() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      setError(err.message === 'Failed to fetch'
        ? 'Unable to connect. Check your internet connection.'
        : err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="al-login-page">
      {/* Left brand panel */}
      <div className="al-login-brand">
        <div className="al-login-brand-inner">
          <img src="/favicon.png" className="al-brand-mark" alt="Dentalis" />
          <h2 className="al-brand-name">Dentalis</h2>
          <p className="al-brand-tagline">Clinic management, simplified.</p>
          <ul className="al-brand-features">
            <li>Manage appointments in real time</li>
            <li>Control slot availability</li>
            <li>Track patient bookings</li>
          </ul>
        </div>
      </div>

      {/* Right form panel */}
      <div className="al-login-form-panel">
        <div className="al-login-form-inner">
          <div className="al-login-heading">
            <h1>Sign in</h1>
            <p>Enter your admin credentials to continue</p>
          </div>

          <form onSubmit={handleSubmit} className="al-login-form">
            {error && (
              <div className="al-login-error" role="alert">
                {error}
              </div>
            )}

            <div className="al-field">
              <label htmlFor="al-username">Username</label>
              <input
                id="al-username"
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter username"
                required
                autoComplete="username"
                autoFocus
              />
            </div>

            <div className="al-field">
              <label htmlFor="al-password">Password</label>
              <input
                id="al-password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                required
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="al-submit-btn" disabled={loading}>
              {loading ? (
                <>
                  <span className="al-spinner" />
                  Signing in…
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
